module.exports = __webpack_public_path__ + "img/mickey124.667e6200.jpg";